/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions"], function (require, exports, Actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ImageDetailsActions = /** @class */ (function (_super) {
        __extends(ImageDetailsActions, _super);
        function ImageDetailsActions() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ImageDetailsActions.getKey = function () {
            return "image-details-actions";
        };
        ImageDetailsActions.prototype.initialize = function () {
            this._setHasImageDetails = new Actions_1.Action();
            this._setImageDetails = new Actions_1.Action();
        };
        Object.defineProperty(ImageDetailsActions.prototype, "setHasImageDetails", {
            get: function () {
                return this._setHasImageDetails;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ImageDetailsActions.prototype, "setImageDetails", {
            get: function () {
                return this._setImageDetails;
            },
            enumerable: true,
            configurable: true
        });
        return ImageDetailsActions;
    }(Actions_1.ActionsHubBase));
    exports.ImageDetailsActions = ImageDetailsActions;
});
